import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@material-ui/core/'

class FormSaveButton extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  }

  render() {
    const {
      children,
      ...buttonProps
    } = this.props

    const props = {
      ...buttonProps,
      color: 'primary',
      variant: 'contained',
    }

    return (
      <Button {...props}>
        { children }
      </Button>
    )
  }
}

export default FormSaveButton
